import { takeLatest } from 'redux-saga/effects';

import { fetchFixedFeeProfitabilityReport } from 'actions/reports';
import { fetchFixedFeeProfitabilityReportSaga } from './fetchFixedFeeProfitabilityReport';

export default function* reportsSaga() {
  yield takeLatest(fetchFixedFeeProfitabilityReport, fetchFixedFeeProfitabilityReportSaga);
}
